import React from "react";
import { Link } from "react-router-dom";
import {
  LayoutDashboard, FlaskConical, Brain, BookOpen, BarChart3, Heart, UserCircle2,
} from "lucide-react";

/**
 * BhiQuickNav — canonical primary navigation used on subpages outside
 * the /dashboard AppShell chrome (BHI, Dental HI, and future subpage
 * modules). Kept in visual + label parity with `AppShell.jsx TABS` so
 * pacients see ONE identical menu everywhere.
 *
 * iter881 — Menu unified with AppShell (7 items):
 *   Моето здраве · Nutrition Lab · Mind & Body Lab · Умно хранене ·
 *   Precision Health · Health Intelligence · Профил
 */
const ITEMS = [
  { to: "/dashboard",                      icon: LayoutDashboard, bg: "Моето здраве",        en: "My Health",           es: "Mi salud" },
  { to: "/dashboard/nutrition-lab",        icon: FlaskConical,    bg: "Хранителна лаборатория", en: "Nutrition Lab",       es: "Nutrition Lab" },
  { to: "/dashboard/mindbody-lab",         icon: Brain,           bg: "Ум и тяло",          en: "Mind & Body Lab",     es: "Mind & Body Lab" },
  { to: "/dashboard/diary",                icon: BookOpen,        bg: "Умно хранене",         en: "Smart Eating",        es: "Alimentación inteligente" },
  { to: "/dashboard/analyses",             icon: BarChart3,       bg: "Precision Health",    en: "Precision Health",    es: "Precision Health" },
  { to: "/dashboard/health-intelligence",  icon: Heart,           bg: "Health Intelligence", en: "Health Intelligence", es: "Health Intelligence" },
  { to: "/dashboard/profile",              icon: UserCircle2,     bg: "Профил",              en: "Profile",             es: "Perfil" },
];

export default function BhiQuickNav({ isDark = false, lang = "bg", activeRoute }) {
  return (
    <nav
      className={`sticky top-0 z-30 -mx-4 sm:-mx-6 mb-6 border-b backdrop-blur-md
        ${isDark
          ? "bg-gradient-to-r from-[hsl(280,40%,10%)]/95 via-[hsl(265,40%,11%)]/95 to-[hsl(320,40%,11%)]/95 border-white/10"
          : "bg-gradient-to-r from-violet-50/95 via-pink-50/85 to-purple-50/90 border-violet-200/60"}`}
      data-testid="bhi-quick-nav"
      aria-label={lang === "en" ? "Main navigation" : "Основна навигация"}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2">
        <div className="flex items-center gap-1 overflow-x-auto">
          {ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = activeRoute && item.to === activeRoute;
            const label = lang === "es" ? item.es : lang === "en" ? item.en : item.bg;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`app-shell-tab-${item.to.replace(/\//g, "-").replace(/^-+/, "")}`}
                className={`shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all whitespace-nowrap
                  ${isActive
                    ? "bg-gradient-to-r from-pink-500 via-fuchsia-500 to-violet-600 text-white shadow-md shadow-violet-500/40 ring-1 ring-white/30"
                    : (isDark
                        ? "text-slate-300 bg-white/[0.04] border border-white/10 hover:text-white hover:bg-white/10 hover:border-pink-500/40"
                        : "text-slate-700 bg-white/70 border border-violet-200/70 hover:text-violet-700 hover:bg-white hover:border-pink-400/60 hover:shadow-sm")}`}
                title={label}
              >
                <Icon className="w-3.5 h-3.5" />
                {label}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
